<template>
  <div class="biblable mt-3" id="select-bib-label">
    <div class="title">Labels</div>
    <b-form-group>
      <b-form-checkbox-group size="sm" v-model="selected" :options="biblabelsOptions" button-variant="secondary"
        buttons></b-form-checkbox-group>
    </b-form-group>
  </div>
</template>

<style scoped>
.biblable {
  margin-top: 11px !important;
}

div.title {
  margin-right: 4px;
}

*>>>.btn-secondary {
  background-color: #e8e8e8 !important;
  color: #000;
  border-color: #b8b8b8 !important;
}
</style>

<script>
// import config from '@/config.js'
import { mapState } from 'vuex'
// import Multiselect from 'vue-multiselect'

export default {
  name: 'BibLableSelectPI',
  data() {
    return {
      selected: [],
    }
  },
  computed: {
    ...mapState({
      biblabels: state => state.common.biblabels,
      userSettingsPI: state => state.user.settingsPI,
    }),
    biblabelsOptions() {
      return this.biblabels.map(biblabel => {
        return {
          'text': biblabel.label,
          'value': biblabel.label
        }
      })
    },
  },
  methods: {
    syncSelected() {
      const configured = this.userSettingsPI.biblabels || []
      const available = new Set(this.biblabels.map(biblabel => biblabel.label))
      const selected = configured.filter(label => available.has(label))
      if (JSON.stringify(selected) !== JSON.stringify(this.selected)) {
        this.selected = selected
      }
    },
  },
  watch: {
    biblabels: {
      immediate: true,
      handler() {
        this.syncSelected()
      },
    },
    'userSettingsPI.biblabels'() {
      this.syncSelected()
    },
    selected(value) {
      if (JSON.stringify(value) === JSON.stringify(this.userSettingsPI.biblabels || [])) {
        return
      }
      this.$store.dispatch(
        'setUserSettingsPI',
        { property: 'biblabels', value: value }
      )
    },
  },
}
</script>
